import React from "react";
import cn from "classnames";

import styles from "./Footer.module.scss";
import { Link } from "react-router-dom";

export default function Footer(props) {
  return (
    <footer className={cn(styles.footer_block, styles.footer_block_layout)}>
      <div className={cn(styles.footer_line, styles.footer_line_layout)} />

      <div className={cn(styles.footer_flex, styles.footer_flex_layout)}>
        <div className={cn(styles.footer_flex_item)}>
          <a
            href="https://nuvve.com/privacy-policy/"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <div
              className={cn(
                styles.footer_text_body,
                styles.footer_text_body_layout
              )}
            >
              {"Privacy"}
            </div>
          </a>
        </div>
        <div className={cn(styles.footer_flex_spacer)} />
        <div className={cn(styles.footer_flex_item)}>
          <a
            href="https://nuvve.com/terms-of-use/"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <div
              className={cn(
                styles.footer_text_body1,
                styles.footer_text_body1_layout
              )}
            >
              {"Terms of use"}
            </div>
          </a>
        </div>
        <div className={cn(styles.footer_flex_spacer1)} />
        <div className={cn(styles.footer_flex_item)}>
          <a
            href="mailto:support@nuvve.com"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            {/* <a href='mailto:Support@Nuvve.com ' target="_blank" style={{"textDecoration": "none"}}> */}
            <div
              className={cn(
                styles.footer_text_body2,
                styles.footer_text_body2_layout
              )}
            >
              {"support@nuvve.com"}
            </div>
          </a>
        </div>
        <div className={cn(styles.footer_flex_spacer2)} />
        <div className={cn(styles.footer_flex_item)}>
          <div
            className={cn(
              styles.footer_text_body3,
              styles.footer_text_body3_layout
            )}
          >
            {"© 2022 NUVVE Corporation"}
          </div>
        </div>
      </div>
    </footer>
  );
}
